import { FunctionComponent } from 'react';

import { Text as RadixText, TextProps } from '@radix-ui/themes';

export const Text: FunctionComponent<TextProps> = (props: TextProps) => {
  return <RadixText {...props} />;
};
